module.exports = __webpack_public_path__ + "img/new-warning-icon.5e60c3ad.svg";